// web_components/wcBanner/wcBanner_Renderer.ts

/**
 * Generates the HTML for the wc-banner component.
 * Handles CSS, variables, etc.
 *
 * @param {object} dataAttributes - Data attributes for styling and contextual information.
 * @param {string} instanceId - A unique instance ID for generating unique element IDs.
 * @returns {string} - The HTML string for the content component.
 */
export function renderProductHTML(dataAttributes: any, instanceId: string): string {
	let styleTag = '';

	// Generate custom styles if provided in dataAttributes.css
	if (dataAttributes.css && typeof dataAttributes.css === 'object') {
		styleTag = `<style>`;
		for (const [selector, styles] of Object.entries(dataAttributes.css)) {
			styleTag += `${selector} { ${styles} }`;
		}
		styleTag += `</style>`;
	}

	// Access variables for responsive images and other banner content
	const variables = dataAttributes.variables || {};

	// Add responsive media query styles for the banner background image
	const responsiveStyles = `
		<style>
			/* Default background image (small) */
			#${instanceId} .wc-banner__container::before {
				background: linear-gradient(180deg, rgba(255, 255, 255, 0), ${variables.bannerImageOverlayMobile});
			}
			
			#${instanceId} .wc-banner__image {
				background-image: url(${variables.imageSmall});
			}

			/* Medium image for screens 640px and above */
			@media (min-width: 640px) {
				#${instanceId} .wc-banner__image {
					background-image: url(${variables.imageMedium});
				}
			}

			/* Large image for screens 1200px and above */
			@media (min-width: 1200px) {
				#${instanceId} .wc-banner__image {
					background-image: url(${variables.imageLarge});
				}
			}
			
			@media (min-width: 1240px) {
				#${instanceId} .wc-banner__container::before {
					background: linear-gradient(212deg, rgba(255, 255, 255, 0) 45%, ${variables.bannerImageOverlayDesktop});
			}
			
			}
		</style>
	`;

	// Return the full HTML structure, including dynamic styles
	return `
    ${styleTag}
    ${responsiveStyles}
    <section id="${instanceId}" class="wc-banner${variables.parallaxEnabled == 'true' ? ' wc-banner__parallax' : ''}${variables.topBanner == 'true' ? ' wc-banner__hero' : ''}">
      <div class="wc-banner__container">
        <div class="wc-banner__image"><i></i></div>
        <div class="wc-banner__content">
          <div class="wc-banner__content-inner">
            <h1 class="wc-banner__heading">${variables.heading}</h1>
            <span class="wc-banner__subheading">${variables.subheading}</span>
            <p class="wc-banner__text">${variables.text}</p>
            ${
				variables.displayTrustpilot == 'true'
					? `
						<img src="${window.serverData.contextPath + '/skin/images/logos/WineBank-TrustPilot-badge-' + variables.trustpilotImageType + '.svg'}" alt="Trustpilot" class="wc-banner__trustpilot" />
					`
					: ''
			}
            <a class="wc-banner__cta${variables.ctaTextLink ? '-link' : '-btn'}" href="${variables.ctaTextLink ? variables.ctaTextLink : variables.ctaLink}">${variables.ctaText}</a>
          </div>
        </div>
      </div>
    </section>
  `;
}
